/**
 *
 *
 * @author fuyg
 * @date  2020-06-10
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from 'src/pages/home/store'
import {
  FinancialSummary,
  getFinancialSummary,
} from 'src/pages/home/apis/financialSummary'

interface FinancialSummaryState {
  loading: boolean
  error: string
  data: FinancialSummary[]
}

const initialState: FinancialSummaryState = {
  loading: false,
  error: '',
  data: [],
}

const FinancialSummarySlice = createSlice({
  name: 'FinancialSummarySlice',
  initialState,
  reducers: {
    getDataStart(state): void {
      state.loading = true
    },
    getDataSuccess(state, action: PayloadAction<FinancialSummary[]>): void {
      state.loading = false
      state.data = action.payload
    },
    getDataError(state, action: PayloadAction<string>): void {
      state.loading = false
      state.error = action.payload
    },
  },
})

export const {
  getDataStart,
  getDataSuccess,
  getDataError,
} = FinancialSummarySlice.actions

export default FinancialSummarySlice.reducer

export const fetchFinancialSummary = (): AppThunk => async (
  dispatch,
): Promise<void> => {
  try {
    dispatch(getDataStart())
    const data = await getFinancialSummary()
    dispatch(getDataSuccess(data))
  } catch (err) {
    dispatch(getDataError(err as string))
  }
}
